<template>
  <BlBackdrop
    label="Update"
    :submitLoading="submitLoading"
    :disabled="isDisabledSubmit"
    @backdrop-close="$emit('close-modal')"
    @backdrop-action="onSubmit"
  >
    <div class="flex flex-col gap-4 px-8 pt-8" :style="{ width: '40rem' }">
      <div class="flex flex-col gap-2">
        <div class="flex items-center">
          <div :style="{ transform: 'scale(1.375)' }" class="pl-2 pr-4">
            <BlInputToggle
              :checked="probingEnableInput"
              @changed="probingEnableInput = !probingEnableInput"
            />
          </div>
          <BlTextTitle4 text="Edit Probing" />
        </div>
        <BlTextBody2
          text="Probing can be employed to assess a skill at various stages of the therapy. Activating probing gives you additional option to conduct probes during the session."
        />
      </div>
      <div class="grid grid-cols-6 gap-4">
        <BlInputText
          class="col-span-3"
          :input="probingTrialInput"
          @changed="inputHandler"
        />
        <BlInputText
          class="col-span-3"
          :input="probingGoalInput"
          @changed="inputHandler"
        />
      </div>
    </div>
  </BlBackdrop>
</template>

<script>
import { mapActions } from "vuex";

import BlBackdrop from "../../../BlBackdrop.vue";
import BlInputToggle from "../../../BlInputToggle.vue";
import BlInputText from "../../../BlInputText.vue";
import BlTextTitle4 from "../../../BlTextTitle4.vue";
import BlTextBody2 from "../../../BlTextBody2.vue";

export default {
  name: "EditProbingModal",
  components: {
    BlBackdrop,
    BlInputToggle,
    BlInputText,
    BlTextTitle4,
    BlTextBody2
  },
  props: ["target"],
  data() {
    return {
      submitLoading: false,
      probingEnableInput: false,
      probingTrialInput: {
        label: "Minimum trials needed",
        placeholder: "Probing's minimum trials",
        model: "",
        asterisk: true,
        suffix: "trials",
        disabled: false
      },
      probingGoalInput: {
        label: "Goal",
        placeholder: "1-100",
        model: "",
        asterisk: true,
        suffix: "percent (%)",
        disabled: false
      }
    };
  },
  computed: {
    isDisabledSubmit() {
      if (this.probingEnableInput) {
        if (!this.probingTrialInput.model) return true;
        if (!this.probingGoalInput.model) return true;
      }
      return false;
    }
  },
  watch: {
    probingEnableInput(val) {
      this.probingTrialInput.disabled = !val;
      this.probingGoalInput.disabled = !val;
    },
    target: {
      deep: true,
      handler(val) {
        this.generateProbingData(val);
      }
    }
  },
  mounted() {
    this.generateProbingData(this.target);
  },
  methods: {
    ...mapActions(["updateTarget", "showToast"]),
    generateProbingData(val = null) {
      if (val) {
        this.probingEnableInput = val.probing_enable;
        this.probingTrialInput.model = val.probing_number_of_trial;
        this.probingGoalInput.model = val.probing_goal;
        this.probingTrialInput.disabled = !val.probing_enable;
        this.probingGoalInput.disabled = !val.probing_enable;
      }
    },
    inputHandler(payload) {
      payload.input.model = payload.value;
    },
    async onSubmit() {
      const params = {
        id: this.target.id,
        target: {
          probing_enable: this.probingEnableInput,
          probing_number_of_trial: Number(this.probingTrialInput.model || "0"),
          probing_goal: Number(this.probingGoalInput.model || "0")
        }
      };
      if (params.target.probing_enable && params.target.probing_goal > 100) {
        const title = "Invalid input";
        const message =
          "Probing goal must be less than or equal to 100 percent(%).";
        this.showToast({ title, message, type: "error" });
        return;
      }

      this.submitLoading = true;
      const { success } = await this.updateTarget(params);
      this.submitLoading = false;
      if (!success) return;

      const title = "Probing updated";
      const message = "Success! The probing has been updated.";
      this.showToast({ title, message, type: "success" });
      this.$emit("close-modal");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/clients/target/modal/EditProbingModal.vue